import { Box, Toolbar as MUIToolbar } from '@mui/material';
import { styled } from '@mui/system';

export const Toolbar = styled(MUIToolbar)(() => ({
	justifyContent: 'space-between',
	// boxShadow: '7px 4px 30px 0px rgba(130, 125, 131, 0.15)',
	padding: '0px 8px 0px 0px',
	background: 'rgba(255, 255, 255, 0.50)',

	borderRadius: '20px',

	'&:has(.homework-modal)::before': {
		background: '#fff',
	},

	'&::before': {
		content: "''",
		position: 'absolute',
		inset: 0,
		background: 'rgba(255,255,255,0.3)',
		backdropFilter: 'blur(10px)',
		borderRadius: '32px',
		zIndex: '-1',
		transition: 'background .3s',
	},
}));

export const Right = styled('div')(() => ({
	display: 'flex',
	alignItems: 'center',
	gap: '4px',
}));

export const Body = styled(Box)({
	height: '100%',
	overflow: 'auto',
});
